import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCountry,
  setItemName,
  setItemNameLat,
  setItemCity,
} from '@/modules/Dictionary/__form/item';
import FDictionaryService from '@/modules/Dictionary/Service/Select';

export default class DictionaryExcursionForm extends DictionaryForm {
  static permission = {
    add: [114],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'additionalService';

  constructor(props = {}) {
    super(props);
    this.setItemService();
    setItemCountry.bind(this)();
    setItemCity.bind(this)();
    setItemName.bind(this)({ length: 300 });
    setItemNameLat.bind(this)({ length: 300 });
  }

  setItemService() {
    this.service = new FDictionaryService({
      name: 'ServiceClassId',
      show: false,
    });
    this.service.$subscribe(() => {
      this.city.show = !!this.service.value?.isCity;
    });
    this.setItem('service', this.service);
  }
}
